<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file BaseLoadingAnimation.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  BaseLoadingAnimation.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div>
        <div v-if="type==='spinner'"
                class="d-flex justify-content-center align-items-center"
        >
            <i class="fa fa-circle-o-notch fa-spin text-center"
                    style="font-size:85px"
            ></i>
        </div>
        <div v-else
                class="preloader-bounce--wrapper"
        >
            <div class="preloader-bounce">
                <div class="loading">
                    <div class="preloader-bounce--bounceball"></div>
                    <div class="preloader-bounce--text text-uppercase">
                        <bold-words :word="{
                                        text:text
                                    }"></bold-words>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
	export default {
		name: "BaseLoadingAnimation",
		props: {
			type: {
				type: String,
				default: 'bounce'
			},
			text: {
				type: String,
				default: 'Loading...'
			}
		}
	}
</script>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseLoadingAnimation.vue